// extracted by mini-css-extract-plugin
export default {"Questions":"Questions_Questions__jWp1b","QuestionsItems":"Questions_QuestionsItems__G246f"};